
import events from 'events';
import $ from '@ali/tarzan-zepto';
import TPL from '../../../baseui/index';
import Field from './field/index';
import { ACTIVED_MOD } from '../../../../const/objects.const';

require('./alime-input.scss');

export default class Input extends events {

  constructor(config = {}) {
    super();
    this.elementSelectors = {
      sendButtonId: '#alime-send-button',
      sendArrowId: '#alime-send-arrow',
      textInputId: '#alime-text-input',
      messageWrapperId: '#alime-message-wrapper',
    };
    this.$container = $(config.container);
    // 只有手淘 手猫支持语音输入
    const buttonSend = config.app.util.lang.get('BUTTON:SEND');
    const html = TPL.frame({ type: 'input', send: buttonSend });
    this.$container.append($(html));
    this.field = this.__initFiled();
  }

  __initFiled() {
    const { sendButtonId, sendArrowId, textInputId, messageWrapperId } = this.elementSelectors;
    const $sendButton = this.$container.find(sendButtonId);
    const $sendArrow = this.$container.find(sendArrowId);
    const $messageWrapper = this.$container.find(messageWrapperId);
    const field = new Field({
      $container: this.$container,
      trigger: this.$container.find(textInputId),
    });

    field.on('resize', () => {
      this.emit('resize');
    });
    field.on('input', (ev) => {
      const isValueAvailable = /([^\s])/.test(ev.newVal);
      if (isValueAvailable) {
        $messageWrapper.addClass(ACTIVED_MOD);
        $sendButton.addClass(ACTIVED_MOD);
        $sendArrow.addClass(ACTIVED_MOD);
      } else {
        $messageWrapper.removeClass(ACTIVED_MOD);
        $sendButton.removeClass(ACTIVED_MOD);
        $sendArrow.removeClass(ACTIVED_MOD);
      }
    });
    field.$field.on('focus.csc', () => {
      setTimeout(() => {
        this.emit('resize');
      }, 300);
    });

    return field;
  }

}



// WEBPACK FOOTER //
// ./src/component/view/footer/input/index.js